import { Component, OnInit, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ApiEnvironmentService } from '../../../services/api/api-environment.service';
import { StorageStatusDto } from '../../../models/dto/storage-status.dto';

/**
 * Avviso persistente, mostrato dopo il login, quando all'avvio il backend non è riuscito a scrivere
 * sull'archivio documenti. Lo stato è quello dell'avvio: cambia solo al riavvio del backend.
 */
@Component({
    selector: 'app-storage-status',
    standalone: true,
    imports: [TranslatePipe],
    template: `
        @if (status && !status.available) {
            <div class="storage-status" role="alert">
                <i class="pi pi-exclamation-triangle"></i>
                <div>
                    <strong>{{ 'common.STORAGE_UNAVAILABLE.TITLE' | translate }}</strong>
                    <div>{{ 'common.STORAGE_UNAVAILABLE.MESSAGE' | translate }}</div>
                    @if (status.message) {
                        <div class="storage-status-detail">{{ 'common.STORAGE_UNAVAILABLE.DETAIL' | translate }} ({{ status.storageType }}): {{ status.message }}</div>
                    }
                </div>
            </div>
        }
    `,
    styles: [
        `
            .storage-status {
                display: flex;
                gap: 0.75rem;
                align-items: flex-start;
                margin-bottom: 1rem;
                padding: 0.75rem 1rem;
                border-radius: 6px;
                background: #fef2f2;
                border: 1px solid #fca5a5;
                color: #991b1b;
            }
            .storage-status .pi {
                font-size: 1.25rem;
                margin-top: 0.1rem;
            }
            .storage-status-detail {
                margin-top: 0.25rem;
                font-size: 0.8rem;
                opacity: 0.85;
            }
        `
    ]
})
export class AppStorageStatus implements OnInit {
    private readonly apiEnvironment = inject(ApiEnvironmentService);

    status?: StorageStatusDto;

    ngOnInit(): void {
        this.apiEnvironment.getStorageStatus().subscribe({
            next: (status) => (this.status = status),
            error: () => (this.status = undefined)
        });
    }
}
